import clsx from "clsx";
import type { FC } from "react";

import { COLUMN_RESIZE } from "@ryde/shared";

import {
  ColumnResizeHandleStyled,
  useColumnResize,
  type IColumnsSizingStore,
} from "./parts";

interface IColumnResizeHandleProps {
  columnId: string;
  columnLabel?: string | null;
  columnWidth?: string | number;
  columnsSizingStore: IColumnsSizingStore;
}

export const ColumnResizeHandle: FC<IColumnResizeHandleProps> = ({
  columnId,
  columnLabel,
  columnWidth,
  columnsSizingStore,
}) => {
  const {
    isResizing,
    ariaLabel,
    ariaValueNow,
    onPointerDown,
    onPointerMove,
    onPointerEnd,
    onKeyDown,
  } = useColumnResize({
    columnId,
    columnLabel,
    columnWidth,
    columnsSizingStore,
  });

  return (
    <ColumnResizeHandleStyled
      role="separator"
      aria-orientation="vertical"
      aria-label={ariaLabel}
      aria-valuenow={ariaValueNow}
      aria-valuemin={COLUMN_RESIZE.minWidth}
      tabIndex={0}
      className={clsx({ is_resizing: isResizing })}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerEnd}
      onPointerCancel={onPointerEnd}
      onLostPointerCapture={onPointerEnd}
      onKeyDown={onKeyDown}
    />
  );
};
